export default __webpack_public_path__ + "static/automotive5-bee859146dc3c77e67420995ac2143da.jpeg";